export const FACILITIES_TABLE_ID = 'facilities-table'

export const LOCALE_TYPE_REGION = 'region';
export const LOCALE_TYPE_BUILDING = 'building';
export const LOCALE_TYPE_AREA = 'area';
export const LOCALE_TYPE_ROOM = 'room';
